import React, { useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';
import './Footer.css';
import {
  FaLinkedin,
  FaTwitter,
  FaYoutube,
  FaFacebook,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaArrowUp,
  FaArrowDown,
  FaArrowRight,
  FaChevronRight,
  FaChevronDown,
  FaChevronUp,
} from 'react-icons/fa';
import footerLogo from '../Assets/footerlogo.png';
import footerWord from '../Assets/footerword.png';
import { FaXTwitter } from 'react-icons/fa6';

const socialIcons = [
  { label: "LinkedIn", url: "#", icon: <FaLinkedin />, color: "#0077B5" },
  { label: "X", url: "#", icon: <FaXTwitter />, color: "#000000" },,
  { label: "YouTube", url: "#", icon: <FaYoutube />, color: "#FF0000" },
  { label: "Facebook", url: "#", icon: <FaFacebook />, color: "#1877F2" },
];

const Footer = () => {
  const [showGoToTop, setShowGoToTop] = useState(false);
  const [showScrollDown, setShowScrollDown] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const windowHeight = window.innerHeight;
      const docHeight = document.documentElement.scrollHeight;

      // Show scroll down only near the top
      setShowScrollDown(scrollY < 100);

      // Show scroll up only when not at top or bottom
      setShowGoToTop(scrollY > 100 && scrollY + windowHeight < docHeight - 50);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToBottom = () => {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: 'smooth',
    });
  };

  return (
    <motion.footer
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      className="footer"
      aria-label="VCNR Footer"
    >
      <div className="footer-logo-row">
        <div className="footer-logo-divider" />
        <div className="footer-logo-center">
          <img src={footerLogo} alt="VCNR Logo" className="footer-logo-img" />
        </div>
        <div className="footer-logo-divider" />
      </div>

      <div className="footer-top">
        <section className="footer-section" aria-labelledby="footer-contact-heading">
          <h2 className="footer-heading" id="footer-contact-heading">Contact</h2>
          <address className="footer-contact">
            <div>
              <FaPhoneAlt className="footer-contact-icon" />
              <a href="tel:08029511531">080 2951 1531</a>&nbsp; |&nbsp;
              <a href="tel:+916364914086">+91 63649 14086</a>
            </div>
            <div>
              <FaEnvelope className="footer-contact-icon" />
              <a
                href="mailto:info@vcnrworld.com"
                className="purple-color"
                style={{ textDecoration: 'none' }}
              >
                info@vcnrworld.com
              </a>
            </div>
            <div className="custom-flex">
              <div>
                <b>
                  <FaMapMarkerAlt className="footer-contact-icon" /> VCNR Group
                </b>
                <br />
              </div>
              <div style={{ marginLeft: '30px', color: '#ffffffab' }}>
                #135, VCNR Towers, Vinayaka nagar,<br />
                BH Road, Binnamangala Nursery,<br />
                Nelamangala Town, Karnataka 562123
              </div>
            </div>
          </address>
        </section>

        <nav className="footer-section" aria-labelledby="footer-nav-heading">
          <h2 className="footer-heading" id="footer-nav-heading">Navigation</h2>
          <ul className="footer-nav">
            <li><a href="/">VCNR Home</a></li>
            <li><a href="/aboutVCNR">About VCNR</a></li>
            <li><a href="/Leadership">Leadership</a></li>
            <li><a href="/Career">Career</a></li>
            <li><a href="/Contact">Contact</a></li>
          </ul>
        </nav>

        <nav className="footer-section">
          <h2 className="footer-heading">Verticals</h2>
          <ul className="footer-nav">
            <li><a href="/Builders">Builders</a></li>
            <li><a href="/Healthcare">Health Care</a></li>
            <li><a href="/Technologies">Technologies</a></li>
            <li><a href="/Goldandiamonds">Gold & Diamonds</a></li>
            <li><a href="/educational">Educational Institutions</a></li>
            <li><a href="/Properties">Properties</a></li>
            <li><a href="/Hospitality">Hospitality</a></li>
            <li><a href="/Agrotech">Agriculture</a></li>
            <li><a href="/Foundation">Hitachinthana Charitable Trust</a></li>
          </ul>
        </nav>

        <section className="footer-section" aria-labelledby="footer-news-heading">
          <h2 className="footer-heading2" id="footer-news-heading">Get stories from the field of fire.</h2>
          <form className="footer-form" aria-label="Newsletter Signup">
            <div className="footer-form-container">
              <input type="email" placeholder="Enter Email Address" required aria-label="Email Address" />
              <motion.button whileHover={{ scale: 1.05 }} type="submit" className="footer-form-btn">
                SIGNUP <FaChevronRight className="footer-form-arrow" />
              </motion.button>
            </div>
          </form>
          <div className="footer-social">
            <span className="footer-heading2">Follow us on</span>
            <div className="footer-icons">
  {socialIcons.map(({ label, url, icon, color }) => (
    <motion.a
      key={label}
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      whileHover={{ scale: 1.15 }}
      className="footer-icon-circle"
      style={{ backgroundColor: color }}   // 🔥 brand color applied here
      aria-label={label}
    >
      {icon}
    </motion.a>
  ))}
</div>

          </div>
        </section>
      </div>

      <div className="footer-divider" />
      <div className="footer-bottom">
        <div className="footer-logo-img-wrap">
          <img src={footerWord} alt="VCNR Wordmark" className="footer-word-img" />
        </div>
        <div className="footer-desc">
          Our growth is a reflection of our values. VCNR is more than an organization — it’s a movement driven by empathy, excellence, and innovation. With every new project, our mission is simple: to improve lives and empower communities.
        </div>
      </div>

      <div className="footer-divider" />
      <div className="footer-links">
        <span><a href="/Privacypolicy">Privacy Policy</a></span>
        <span><a href="/Termsandconditions">Terms & Conditions</a></span>
        <span className="footer-copy">
          © 2025. <a href="https://www.vcnrworld.com" className="purple-color" style={{ textDecoration: 'none' }}>VCNR Group.</a> All rights reserved. Designed & Developed by <a href="https://www.digiworq.com" className="purple-color" target="_blank" style={{ textDecoration: 'none' }}>DIGIWORQ</a>
        </span>
      </div>

      {/* Scroll Buttons */}
      {showScrollDown && (
        <button className="go-to-down-btn" aria-label="Scroll down" onClick={scrollToBottom}>
          <FaChevronDown />
        </button>
      )}
      {showGoToTop && (
        <button className="go-to-top-btn" aria-label="Go to top" onClick={scrollToTop}>
          <FaChevronUp />
        </button>
      )}
    </motion.footer>
  );
};

export default Footer;
